import React, { useState } from 'react';

const Commondefects = () => {

    // images from public/images folder
    const images = [
        process.env.PUBLIC_URL + '/images/common-defects-img/Common Defect- 1Resize.jpg',
        process.env.PUBLIC_URL + '/images/common-defects-img/Common Defect- 2Resize.jpg',
        process.env.PUBLIC_URL + '/images/common-defects-img/Common Defect- 3Resize.jpg',
        process.env.PUBLIC_URL + '/images/common-defects-img/Common Defect- 4Resize.jpg',
        process.env.PUBLIC_URL + '/images/common-defects-img/Common Defect- 5Resize.jpg',
        process.env.PUBLIC_URL + '/images/common-defects-img/Common Defect- 6Resize.jpg',
        process.env.PUBLIC_URL + '/images/common-defects-img/Common Defect- 7Resize.jpg',
        process.env.PUBLIC_URL + '/images/common-defects-img/Common Defect- 8Resize.jpg',
        process.env.PUBLIC_URL + '/images/common-defects-img/Common Defect- 9Resize.jpg',
        process.env.PUBLIC_URL + '/images/common-defects-img/Common Defect- 10Resize.jpg',
        process.env.PUBLIC_URL + '/images/common-defects-img/Common Defect- 11Resize.jpg',
        process.env.PUBLIC_URL + '/images/common-defects-img/Common Defect- 12Resize.jpg',
        process.env.PUBLIC_URL + '/images/common-defects-img/Common Defect- 13Resize.jpg',
        process.env.PUBLIC_URL + '/images/common-defects-img/Common Defect- 14Resize.jpg',
        process.env.PUBLIC_URL + '/images/common-defects-img/Common Defect- 15Resize.jpg',
        process.env.PUBLIC_URL + '/images/common-defects-img/Common Defect- 16Resize.jpg',
        process.env.PUBLIC_URL + '/images/common-defects-img/Common Defect- 17Resize.jpg',
        process.env.PUBLIC_URL + '/images/common-defects-img/Common Defect- 18Resize.jpg',
        process.env.PUBLIC_URL + '/images/common-defects-img/Common Defect- 19Resize.jpg',
        process.env.PUBLIC_URL + '/images/common-defects-img/Common Defect- 20Resize.jpg',
        process.env.PUBLIC_URL + '/images/common-defects-img/Common Defect- 21Resize.jpg',
        process.env.PUBLIC_URL + '/images/common-defects-img/Common Defect- 22Resize.jpg',
        process.env.PUBLIC_URL + '/images/common-defects-img/Common Defect- 23Resize.jpg',
        process.env.PUBLIC_URL + '/images/common-defects-img/Common Defect- 24Resize.jpg',
        process.env.PUBLIC_URL + '/images/common-defects-img/Common Defect- 25Resize.jpg',
        process.env.PUBLIC_URL + '/images/common-defects-img/Common Defect- 26Resize.jpg',
        process.env.PUBLIC_URL + '/images/common-defects-img/Common Defect- 27Resize.jpg',
        process.env.PUBLIC_URL + '/images/common-defects-img/Common Defect- 28Resize.jpg',
        process.env.PUBLIC_URL + '/images/common-defects-img/Common Defect- 29Resize.jpg',
        process.env.PUBLIC_URL + '/images/common-defects-img/Common Defect- 30Resize.jpg',
        process.env.PUBLIC_URL + '/images/common-defects-img/Common Defect- 31Resize.jpg',
        process.env.PUBLIC_URL + '/images/common-defects-img/Common Defect- 32Resize.jpg',
        process.env.PUBLIC_URL + '/images/common-defects-img/Common Defect- 33Resize.jpg',
        process.env.PUBLIC_URL + '/images/common-defects-img/Common Defect- 34Resize.jpg',
        process.env.PUBLIC_URL + '/images/common-defects-img/Common Defect- 35Resize.jpg',
        process.env.PUBLIC_URL + '/images/common-defects-img/Common Defect- 36Resize.jpg',
        process.env.PUBLIC_URL + '/images/common-defects-img/Common Defect- 37Resize.jpg',
        process.env.PUBLIC_URL + '/images/common-defects-img/Common Defect- 38Resize.jpg',
        process.env.PUBLIC_URL + '/images/common-defects-img/Common Defect- 39Resize.jpg',
        process.env.PUBLIC_URL + '/images/common-defects-img/Common Defect- 40Resize.jpg',
        process.env.PUBLIC_URL + '/images/common-defects-img/Common Defect- 41Resize.jpg',
        process.env.PUBLIC_URL + '/images/common-defects-img/Common Defect- 42Resize.jpg',
        process.env.PUBLIC_URL + '/images/common-defects-img/Common Defect- 43Resize.jpg',
        process.env.PUBLIC_URL + '/images/common-defects-img/Common Defect- 44Resize.jpg',
        process.env.PUBLIC_URL + '/images/common-defects-img/Common Defect- 45Resize.jpg',
        process.env.PUBLIC_URL + '/images/common-defects-img/Common Defect- 46Resize.jpg',
        process.env.PUBLIC_URL + '/images/common-defects-img/Common Defect- 47Resize.jpg',
        process.env.PUBLIC_URL + '/images/common-defects-img/Common Defect- 48Resize.jpg',
        process.env.PUBLIC_URL + '/images/common-defects-img/Common Defect- 49Resize.jpg',
        process.env.PUBLIC_URL + '/images/common-defects-img/Common Defect- 50Resize.jpg',

    ];

    const [selectedImage, setSelectedImage] = useState(null);

    // ✅ Pagination states
    const [currentPage, setCurrentPage] = useState(1);
    const imagesPerPage = 6;

    const indexOfLastImage = currentPage * imagesPerPage;
    const indexOfFirstImage = indexOfLastImage - imagesPerPage;
    const currentImages = images.slice(indexOfFirstImage, indexOfLastImage);

    const totalPages = Math.ceil(images.length / imagesPerPage);

    // ✅ Prev / Next handlers
    const handlePrev = () => {
        if (currentPage > 1) {
            setCurrentPage(currentPage - 1);
        }
    };

    const handleNext = () => {
        if (currentPage < totalPages) {
            setCurrentPage(currentPage + 1);
        }
    };

    // ✅ LIMIT PAGINATION (max 4 buttons)
    const getPageNumbers = () => {
        const maxButtons = 4;

        let start = Math.max(currentPage - 2, 1);
        let end = start + maxButtons - 1;

        if (end > totalPages) {
            end = totalPages;
            start = Math.max(end - maxButtons + 1, 1);
        }

        const pages = [];
        for (let i = start; i <= end; i++) {
            pages.push(i);
        }
        return pages;
    };

    return (
        <section className='Commondefects-section'>
            <div className='container'>
                <div className='inner-content'>

                    {/* Heading */}
                    <h2 className='section-heading'>Common Defects</h2>

                    <div className='row-wrapper'>
                        <div className='img-box'>

                            {/* Image Gallery */}
                            <div className="image-grid">
                                {currentImages.map((img, index) => (
                                    <div className='box-001-img' key={index}>
                                        <img
                                            src={img}
                                            alt={`defect-${index}`}
                                            className="grid-image"
                                            onClick={() => setSelectedImage(img)}
                                        />
                                    </div>
                                ))}
                            </div>

                            {/* ✅ Pagination Controls */}
                            <div className="pagination">

                                <button
                                    onClick={handlePrev}
                                    disabled={currentPage === 1}
                                >
                                    Prev
                                </button>

                                {getPageNumbers().map((page) => (
                                    <button
                                        key={page}
                                        className={currentPage === page ? 'active' : ''}
                                        onClick={() => setCurrentPage(page)}
                                    >
                                        {page}
                                    </button>
                                ))}

                                <button
                                    onClick={handleNext}
                                    disabled={currentPage === totalPages}
                                >
                                    Next
                                </button>

                            </div>

                            {/* Modal */}
                            {selectedImage && (
                                <div className="modal">
                                    <div className='modal-content-wrap'>
                                        <span
                                            className="close-btn"
                                            onClick={() => setSelectedImage(null)}
                                        >
                                            &times;
                                        </span>
                                        <div className='modal-img-box'>
                                            <img
                                                src={selectedImage}
                                                alt="zoomed"
                                                className="modal-image"
                                            />
                                        </div>
                                    </div>
                                </div>
                            )}

                            {/* keep your original img tag untouched */}
                            <img src='' style={{ display: 'none' }}></img>

                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Commondefects;